import type { ToolCore } from "@loumy/contracts";
import { spriteSheetCore } from "./spritesheet";
import { imageGeneratorCore } from "./image-generator";
import { chromaKeyRemoverCore } from "./chroma-key-remover";
import { bgRemoveCore } from "./bg-remove";
import { imageUpscaleCore } from "./image-upscale";
import { studioExportCore } from "./studio-export";

// @loumy/tools — 6 ToolCores (§10): dünne Komposition über die geteilten
// Capabilities (§6). Public-API-Allowlist (D46/D160): die fünf Generations-Tools
// (image-generator, chroma-key-remover, spritesheet, bg-remove, image-upscale) sind über
// Public-API + MCP verfügbar; studio-export bleibt intern (Studio-Timeline-State). Diese Menge
// ist die SSOT — das public-gateway (isAllowlisted) UND der lokale MCP-Server (Cloud-Modus)
// importieren sie hier.
export {
  spriteSheetCore,
  makeSpriteSheetSettings,
  periodForAction,
  PERIOD_LOOKUP,
  SPRITESHEET_MODELS,
  MAX_FRAMES,
  MIN_LOOP_FRAMES,
  type SpriteSheetSettings,
} from "./spritesheet";
export { imageGeneratorCore, ImageGeneratorSettings, IMAGE_GENERATOR_MODELS, megapixelsOf } from "./image-generator";
export { chromaKeyRemoverCore, ChromaKeyRemoverSettings } from "./chroma-key-remover";
export { bgRemoveCore, BgRemoveSettings } from "./bg-remove";
export { imageUpscaleCore, ImageUpscaleSettings, UPSCALE_SCALES, UPSCALE_VARIANTS } from "./image-upscale";
export { studioExportCore, StudioExportSettings } from "./studio-export";

/** Alle ToolCores (eager, server). ToolUI (§3.4) ist Frontend-Sache (out-of-scope). */
export const ALL_TOOL_CORES: ToolCore[] = [
  spriteSheetCore,
  imageGeneratorCore,
  chromaKeyRemoverCore,
  bgRemoveCore,
  imageUpscaleCore,
  studioExportCore,
];

/**
 * §2/D46/D160 — Public-Exposure-Allowlist (SSOT): NUR diese Tool-ids sind über die Public-API
 * (POST /v1/jobs) und MCP (tools/call) erreichbar. `studio-export` bleibt bewusst INTERN
 * (Studio-Timeline-State). Ein neues Tool wird öffentlich erst, wenn es hier eingetragen wird.
 */
export const PUBLIC_TOOL_ALLOWLIST: ReadonlySet<string> = new Set([
  "image-generator",
  "chroma-key-remover",
  "spritesheet",
  "bg-remove",
  "image-upscale",
]);
